import { render, staticRenderFns } from "./FiberPopin.vue?vue&type=template&id=5d825b4d&scoped=true"
import script from "./FiberPopin.vue?vue&type=script&lang=js"
export * from "./FiberPopin.vue?vue&type=script&lang=js"
import style0 from "./FiberPopin.vue?vue&type=style&index=0&id=5d825b4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d825b4d",
  null
  
)

export default component.exports